module.exports = __webpack_public_path__ + "img/8.2683de45.jpg";